const company = (company = [], action) => {
  switch (action.type) {
    case 'FETCH_COMPANY_INFORMATION':
      return action.payload
    default:
      return company
  }
}
export default company
